var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.557 5.558L8.123 9l3.434 3.443L10.5 13.5 6 9l4.5-4.5 1.057 1.058z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjU1NzUgNS41NTc1TDguMTIyNSA5TDExLjU1NzUgMTIuNDQyNUwxMC41IDEzLjVMNiA5TDEwLjUgNC41TDExLjU1NzUgNS41NTc1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgBackArrowWhite as ReactComponent };